import useTranslation from 'common/hooks/useTranslation';
import { isEmpty, isNil } from 'lodash';
import React from 'react';

import { TablePagination } from '../../talent/components/TablePagination';
import { OfferTableItem } from './OfferTableItem';
import { OffersTableEmptyState } from './OffersTableEmpyState';

export const OfferTable = ({
  openOffers,
  isLoading,
  currentTab,
  pageIndex,
  pageSize,
  handlePageChange,
  totalPages,
  total,
}) => {
  const { t } = useTranslation('offers\\index');

  return (
    <div className='w-full h-full relative mt-6'>
      {isNil(openOffers) || isEmpty(openOffers?.items) ? (
        <OffersTableEmptyState isLoading={isLoading} currentTab={currentTab} />
      ) : (
        <div className='w-full py-6'>
          <table className='w-full table-auto'>
            <thead className='text-sm text-weldon-blue font-semibold uppercase border-b border-bright-grey'>
              <tr>
                <th className='pb-5 whitespace-nowrap min-w-fit'>
                  <div className='font-semibold text-left '>
                    {' '}
                    {t('process')}
                  </div>
                </th>
                <th className='pb-5 whitespace-nowrap min-w-fit'>
                  <div className='font-semibold text-left'>
                    {' '}
                    {t('offer-status')}
                  </div>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {openOffers?.items?.map(
                ({
                  id,
                  created_at,
                  name,
                  slug,
                  status,
                  owner_id,
                  external_source,
                  n_submissions,
                }) => {
                  return (
                    <OfferTableItem
                      key={id}
                      created_at={created_at}
                      name={name}
                      slug={slug}
                      status={status}
                      owner_id={owner_id}
                      externalSource={external_source}
                      nSubmissions={n_submissions}
                    />
                  );
                },
              )}
            </tbody>
          </table>
          <TablePagination
            pageIndex={pageIndex}
            handlePageChange={handlePageChange}
            pageSize={pageSize}
            totalPages={totalPages}
            total={total}
            i18nNamespace='offers\\index'
          />
        </div>
      )}
    </div>
  );
};
